export type Department = 'Engineering' | 'AI' | 'Product' | 'Sales' | 'HR' | 'Marketing' | 'Executive' | 'Operations';
export type Designation = 'CEO' | 'CTO' | 'COO' | 'VP' | 'Director' | 'Manager' | string;

export interface TimelineEntry {
  year: string;
  label: string;
}

export interface LeadershipMember {
  id: number;
  name: string;
  designation: Designation;
  department: Department;
  image: string;
  linkedin: string;
  bio: string;
  degree: string;
  experience: string;
  areaOfWork: string;
  skills: string[];
  timeline: TimelineEntry[];
  certifications: string[];
  email: string;
}

/** Populated leadership profiles for Ronak, Mehul, and Kashyap. */
export const LEADERSHIP: LeadershipMember[] = [
  {
    id: 1,
    name: 'Ronak',
    designation: 'CEO & Founder',
    department: 'Executive',
    image: '/leadership/ronak.webp',
    linkedin: 'https://linkedin.com',
    bio: 'Leading Resolute’s mission to establish verification-first real estate transactions with complete transparency, data-backed property valuations, and seamless digital execution.',
    degree: 'B.Tech & MBA (Real Estate Strategy)',
    experience: '12+ Years Industry Leadership',
    areaOfWork: 'Real Estate Strategy & Operations',
    skills: ['Real Estate Strategy', 'Business Growth', 'Market Valuation', 'Capital Allocation'],
    timeline: [
      { year: '2024 - Present', label: 'Founder & CEO at Resolute Property Solutions' },
      { year: '2019 - 2024', label: 'VP of Operations & Growth at PropTech Innovators' },
      { year: '2014 - 2019', label: 'Senior Real Estate Strategy Consultant' },
    ],
    certifications: ['Certified Real Estate Executive (CREE)', 'Licensed Property Advisor'],
    email: 'ronak@resoluteproperty.in',
  },
  {
    id: 2,
    name: 'Mehul',
    designation: 'Co-Founder & CTO',
    department: 'Engineering',
    image: '/leadership/mehul.webp',
    linkedin: 'https://linkedin.com',
    bio: 'Architecting Resolute’s core verification engine, AI smart property search, and automated title validation systems to transform how property is evaluated and acquired.',
    degree: 'M.S. in Computer Science',
    experience: '10+ Years Tech & Product Architecture',
    areaOfWork: 'AI Verification & Tech Architecture',
    skills: ['AI Systems Architecture', 'Automated Valuation Models', 'Platform Engineering', 'Data Security'],
    timeline: [
      { year: '2024 - Present', label: 'Co-Founder & CTO at Resolute Property Solutions' },
      { year: '2018 - 2024', label: 'Lead AI & Systems Architect at Enterprise Tech' },
      { year: '2014 - 2018', label: 'Senior Full Stack Engineer' },
    ],
    certifications: ['AWS Certified Solutions Architect - Professional', 'AI Systems Lead'],
    email: 'ronak@resoluteproperty.in',
  },
  {
    id: 3,
    name: 'Kashyap',
    designation: 'Co-Founder & COO',
    department: 'Operations',
    image: '/leadership/kashyap.webp',
    linkedin: 'https://linkedin.com',
    bio: 'Managing physical property inspection networks, legal verification frameworks, and customer success operations to guarantee 100% verified property listings.',
    degree: 'MBA in Operations & Finance',
    experience: '9+ Years Operations & Legal Compliance',
    areaOfWork: 'Ground Operations & Legal Due Diligence',
    skills: ['Legal Due Diligence', 'Ground Audit Networks', 'Customer Experience', 'Risk Management'],
    timeline: [
      { year: '2024 - Present', label: 'Co-Founder & COO at Resolute Property Solutions' },
      { year: '2019 - 2024', label: 'Head of Legal & Field Audit Operations' },
      { year: '2015 - 2019', label: 'Senior Valuation & Compliance Manager' },
    ],
    certifications: ['Certified Legal Due Diligence Specialist', 'ISO Operations Quality Lead'],
    email: 'ronak@resoluteproperty.in',
  },
];

